<template>
    <div class="industrialService">
        <img src="../../assets/imgs/bg.jpg">
    </div>
</template>
<script>
export default {
    data(){
        return{

        }
    },
    mounted(){
        this.$parent.current = '5';
    }
}
</script>

<style>
.industrialService{
    width: 1300px;
    margin:0 auto;
}
</style>